import { createContext } from "react";
import type { OneRepMaxActionsContextType } from "./OneRepMaxActionsContext.types";

const OneRepMaxActionsContext = createContext<OneRepMaxActionsContextType | undefined>(undefined);
OneRepMaxActionsContext.displayName = "OneRepMaxActionsContext";

export default OneRepMaxActionsContext;
